import { ReactElement } from 'react';
import { S_TabsCard } from '../../../../design/card/tabsCard/S_TabsCards';
import { DashboardContainer } from '../../../../modules/common/dashboard/DashboardContainer';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { ProjectDetailsHeaderContainer } from '../../../modules/projectDetails/containers/ProjectDetailsHeader.container';
import { ProjectDetailsTabsContainer } from '../../../modules/projectDetails/containers/ProjectDetailsTabs.container';
import { ProjectDetailsRoute } from '../../../routes/projects/projectDetails.route';

export const ProjectDetailsView = (): ReactElement => (
  <DashboardContainer>
    <ProjectDetailsHeaderContainer />
    <ColumnLayout size='none'>
      <ProjectDetailsTabsContainer />
      <S_TabsCard>
        <ProjectDetailsRoute />
      </S_TabsCard>
    </ColumnLayout>
  </DashboardContainer>
);
